import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { getRestaurantNote } from 'restaurantAdmin/reservations/service/apiHelpers';
import { DATE_PARAM, DATE_PARAM_FORMAT } from 'restaurantAdmin/utils/constants';
import { useServiceSearchParams } from 'restaurantAdmin/reservations/service/hooks/useServiceSearchParams';
import { IconButton } from '@components/iconButton/IconButton';
import { useAbortEffect } from '@shared/hooks/useAbortEffect';
import { toISODateFormat } from '@shared/utils/dateFormatters';
import cx from 'classnames';
import { isValid, parse } from 'date-fns';
import { useMemo, useState } from 'react';
import styles from './ServiceOverviewButton.scss';

export const ServiceOverviewButton = () => {
  const { id: restaurantId } = useRestaurant();
  const { searchParams, openServiceOverviewDrawer } = useServiceSearchParams();
  const searchParamsDate = searchParams.get(DATE_PARAM) || '';

  const [dayNote, setDayNote] = useState('');

  const dayNoteDate = useMemo(() => {
    const parsedDate = parse(searchParamsDate, DATE_PARAM_FORMAT, new Date());
    return isValid(parsedDate) ? parsedDate : new Date();
  }, [searchParamsDate]);

  const fetchRestaurantNote = async () => {
    const response = await getRestaurantNote({
      restaurantId,
      date: toISODateFormat(dayNoteDate),
    });

    const noDayNoteForDay = response === null;
    if (noDayNoteForDay) return;
    setDayNote(response.note);
  };

  useAbortEffect(() => fetchRestaurantNote(), [dayNoteDate]);

  const handleClick = () => {
    openServiceOverviewDrawer();
  };

  const hasNote = Boolean(dayNote);

  const buttonAriaLabel = () => {
    return 'View this days service overview';
  };

  return (
    <IconButton
      ariaLabel={buttonAriaLabel()}
      className={cx({
        [styles.noteButton]: true,
        [styles.hasNote]: hasNote,
      })}
      iconName="note"
      onClick={handleClick}
      tooltipContent="Service Overview"
      dataTooltipId="service-overview-tooltip"
      place="bottom"
    />
  );
};
